import React from "react";
import AlberoStrutturaTipiImpExpView from "./AlberoStrutturaTipiImpExpView";

export default function AlberoStrutturaTipiImpExpController({
                                                      treeData,
                                                      tipoSel,
                                                      translate,
                                                      history,
                                                      setTipoSel,
                                                      setShowConfirm,
                                                  }) {

    const vociClickDestro = [
        {
            title: translate("Aggiungi figlio"),
            icon: "fas fa-plus",
            fun: (el) => {
                history.push("/add-tipo-imp-exp-figlio/" + el.id + '/' + el.id_classe);
            }
        },
        {
            title: translate("Modifica"),
            icon: "fas fa-pen",
            fun: (el) => {
                history.push('/upd-tipo-imp-exp/' + el.id);
            }
        },
        {
            title: translate("Elimina"),
            icon: "fas fa-trash",
            fun: (el) => {
                setTipoSel(el);
                setShowConfirm(true);
            }
        },
    ];

    return (
        <AlberoStrutturaTipiImpExpView
            treeData={treeData}
            tipoSel={tipoSel}
            vociClickDestro={vociClickDestro}
        />
    );
}